/* eslint-disable */
const enLocale = require("element-ui/lib/locale/lang/en");
const en = {
  time: 'time',
  ...enLocale.default
};

export default en;
